/* eslint-disable react/jsx-props-no-spreading */
import { useForm } from '@folklore/forms';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useApi } from '../../contexts/ApiContext';
import { useUrlGenerator } from '../../contexts/RoutesContext';
import PillButton from '../buttons/Pill';
import Arrow from '../icons/Arrow';

import styles from '../../../styles/forms/newsletter-email.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

// TODO: improve this if user is logged in
const NewsletterEmail = ({ className }) => {
    const intl = useIntl();
    const route = useUrlGenerator();
    const api = useApi();
    const [success, setSuccess] = useState();

    const subscribe = useCallback((action, data) => api.newsletter.subscribe(data), [api]);

    const onSuccess = useCallback(() => {
        setSuccess(true);
    }, [setSuccess]);

    const { fields, loading, onSubmit } = useForm({
        postForm: subscribe,
        fields: ['email'],
        value: null,
        onComplete: onSuccess,
    });

    // Clear it on success
    useEffect(() => {
        const { onChange: onChangeEmail } = fields.email;
        if (success && onChangeEmail !== null) {
            onChangeEmail('');
        }
    }, [success]);

    const onChange = useCallback(
        (e) => {
            const { onChange: onChangeEmail } = fields.email;
            if (onChangeEmail !== null) {
                onChangeEmail(e.target.value);
            }
        },
        [fields],
    );

    return (
        <form
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            action={route('api.newsletter.subscribe')}
            onSubmit={onSubmit}
            disabled={success}
        >
            <h3 className={styles.heading}>
                <FormattedMessage
                    defaultMessage="Subscribe to FNC’s newsletter"
                    description="Heading"
                />
            </h3>
            <div className={styles.field}>
                <input
                    type="email"
                    className={styles.email}
                    placeholder={
                        success
                            ? intl.formatMessage({
                                  defaultMessage: 'Thank you!',
                                  description: 'Field placeholder',
                              })
                            : intl.formatMessage({
                                  defaultMessage: 'your@email.here',
                                  description: 'Field placeholder',
                              })
                    }
                    onChange={onChange}
                    value={success ? '' : fields?.email?.value || ''}
                    disabled={success}
                />
                <PillButton
                    className={styles.submit}
                    iconClassName={styles.submitIcon}
                    icon={<Arrow />}
                    type="submit"
                    loading={loading}
                    isDark
                />
            </div>
        </form>
    );
};

NewsletterEmail.propTypes = propTypes;
NewsletterEmail.defaultProps = defaultProps;

export default NewsletterEmail;
